/* Free shipping progress bar — continuity across re-renders.

   The fill grows with a keyframe rather than a transition because every cart change re-renders the
   whole surface and hands back a brand new element (see component-cart-shipping-bar.css for the
   full reasoning). A keyframe on its own always starts at zero, so adding a second item made the
   bar snap back to empty and re-fill from scratch instead of carrying on from the figure the
   shopper was already looking at.

   This remembers the width last drawn on each surface and feeds it back as the keyframe's starting
   point, so an update animates from the old figure to the new one — and shrinks back down the same
   way when a line is removed. The first bar of a page load still grows from empty: there is no
   earlier figure to continue from, and that opening sweep is what makes the bar read as progress. */

(() => {
  if (window.mrcShipBarLinked) return;
  window.mrcShipBarLinked = true;

  // Each surface keeps its own figure. The cart page and the drawer can both be in the document,
  // and the drawer landing at 40% must not rob the page's bar of its own starting point.
  const lastWidth = new Map();

  const surfaceOf = (fill) => (fill.closest('cart-drawer') ? 'drawer' : 'page');

  // The width Liquid drew is the honest starting point: it is already clamped to the 3% minimum the
  // 6px track needs to show anything, so animating from it lines up with what was on screen.
  const drawnWidth = (fill) => fill.style.width || '0%';

  const link = (fill) => {
    if (fill.dataset.shipLinked) return;
    fill.dataset.shipLinked = 'true';

    const surface = surfaceOf(fill);
    const previous = lastWidth.get(surface);

    // Left unset on the very first bar, so the keyframe falls back to its own `from: 0`.
    if (previous !== undefined) fill.style.setProperty('--mrc-ship-from', previous);

    lastWidth.set(surface, drawnWidth(fill));
  };

  const scan = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.classList.contains('mrc-ship__fill')) link(node);
    node.querySelectorAll('.mrc-ship__fill').forEach(link);
  };

  scan(document.body);

  /* Both surfaces swap their own innerHTML — cart-drawer.js replaces #CartDrawer, cart.js replaces
     .js-contents and, on an add, <cart-items> wholesale — and none of that fires an event carrying
     the new fill. Watching the two elements that outlive every one of those swaps does. */
  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(scan));
  });

  document.querySelectorAll('cart-drawer, cart-items').forEach((root) => {
    observer.observe(root, { childList: true, subtree: true });
  });
})();
